/**
 * Basic class for two-dimensional point and some operations with it
 */
export class Point
{
    public value:any;

    constructor(public x:number = 0.0, public y:number = 0.0, public z:number = 0.0){}

    add(b:Point):Point              { return new Point(this.x + b.x, this.y + b.y, this.z + b.z); }
    addXY(x:number, y:number):Point { return new Point(this.x + x, this.y + y);}
    subXY(x:number, y:number):Point { return new Point(this.x - x, this.y - y);}
    mulXY(x:number, y:number):Point { return new Point(this.x * x, this.y * y);}
    sub(b:Point):Point              { return new Point(this.x - b.x, this.y - b.y, this.z - b.z); }
    int(b:Point, t:number):Point    { return new Point((1-t) * this.x + t * b.x, (1-t) * this.y + t * b.y, (1-t) * this.z + t * b.z); }    
    len():number                    { return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z); }
    mul(s:number):Point             { return new Point(this.x * s, this.y * s, this.z * s); }
    dot(b:Point):number             { return this.x * b.x + this.y * b.y + this.z * b.z; }
    norm():Point                    { return this.mul(1.0/this.len())}

    static Lerp(a:Point, b:Point, t:number):Point { return a.int(b,t); }
}

/**
 * Extends Point by adding path modifier characters (`m`).
 * The modifier stores SVG-compliant path construction commands such as M (move to), L (line to), C (curve to), etc...
 */
export class PathPoint extends Point
{
    constructor(public x:number = 0, public y:number = 0, public z:number = 0, public m:string = '')
    {
        super(x,y,z);
    }
}

/**
 * Simple rectangle structure
 */
export class Rectangle
{
    origin:Point;
    
    get right():number {return this.left + this.width}
    get bottom():number {return this.top + this.height}

    constructor (public width:number = 0, public height:number = 0, public left:number = 0, public top:number = 0)
    {
        this.origin = new Point(left, top);
    }

    contains(p:Point)
    {
        return (p.x >= this.left && p.x <= this.right && p.y >= this.top && p.y <= this.bottom);
    }

    intersects(another:Rectangle):boolean
    {        
        return ((this.left >= another.left && this.left <= another.right) || (another.left >= this.left && another.left <= this.right)) && ((this.top >= another.top && this.top <= another.bottom) || (another.top >= this.top && another.top <= this.bottom));        
    }
}
